import { http } from "@shared/utils/request";
import type { AsyncTaskDetail } from "@shared/types/asyncTask";

/**
 * 批量查询异步任务详情。
 * 管理端 / 客户端接口结构一致，仅前缀不同：/manage/asyncTask/batchDetail、/customer/asyncTask/batchDetail。
 * basePath 由各端在 App 启动时通过 asyncTaskStore.configure({ basePath }) 注入。
 */
export function fetchAsyncTaskBatchDetail(basePath: string, taskIds: string[]) {
    return http.post<{ items: AsyncTaskDetail[] }>(`${basePath}/asyncTask/batchDetail`, { taskIds });
}
